/* globals searchApp, WidgetDirective */
import icon from './search-list.png.js';
import template from './search_list_widget_view.html';
import templateMaxView from './search_list_widget_max.html';

angular
    .module('MW.Search.SearchListWidget', [
        'MW.Dashboard.DashboardWidgetService',
        'MW.Framework.CoreSearchService',
        'MW.Framework.ContentBehaviorService',
        'DashboardChartConfigService',
        'MW.Framework.CoreUserService',
        'MW.Framework.CoreCompanyService',
        'MW.Framework.CoreCommon',
        'MW.Dashboard.DashboardStateService',
        'MW.Framework.UriService',
        'MW.Framework.SavedSearchService',
        'MW.Framework.InformationTypeService',
        'MW.Framework.TagSearchService',
        'MW.Framework.ContentStreamTypeFactory',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.TagService',
        'MW.Framework.TextFilters',
        'MW.Dashboard.CommentService',
        'MW.Dashboard.ExportService',
        'MW.Framework.DataExportService',
        'MW.Framework.Breadcrumb',
        'MW.Framework.AppBarTitleService',
        'MW.Dashboard.SelectedFilterDisplay',
        'MW.Framework.NavBarService',
        'MW.Framework.AppChromeService',
        'MW.Framework.AnalyticsService',
        'MW.Framework.AnalyticsConstants',
        'MW.Framework.PageStateService',
        'MW.Framework.CoreContentStream'
    ]).run(['DashboardWidgetService', 'InformationTypeService', function (DashboardWidgetService, InformationTypeService) {
    'use strict';

    DashboardWidgetService.register({
        app: 'search',
        name: 'Content Stream',
        allowExport: true,
        availableExportTypes: ['SIMPLE_EXCEL_EXPORT', 'ADVANCED_EXCEL_EXPORT'],
        height: '1',
        enableMaxOverlay: false,
        description: 'The Content Stream widget displays a preview of the latest documents from a set of searches, tags or RSS inputs. The widget can display up to 5 inputs.',
        directive: 'search-list-widget',
        icon,
        defaultSettings: {
            title: 'Title',
            width: 'third',
            maxAgents: 5
        },
        displayOrder: 1,
        requiredSettings: [],
        availableSettings : ['dateRange', 'title', 'news', 'social', 'broadcast', 'rss','tags'],
        template,
        templateMaxView,
        reportAs: 'html',
        hasRequiredSettings: function hasRequiredSettings(){
            if(this.settings && this.settings.inputs && this.settings.inputs.length > 0){
                return true;
            }

            // widget_inputs account for old style
            if(this.settings && this.settings.searchIds && this.settings.searchIds.length > 0){
                return true;
            }
            if(this.settings && this.settings.tagNames && this.settings.tagNames.length > 0){
                return true;
            }
            // *************************************

            return false;
        }
    });
}]);

angular
    .module('MW.Search.SearchListWidget')
    .directive('searchListWidget', ['DashboardWidgetService', 'CoreSearchService', 'ContentBehaviorService', 'DashboardChartConfigService', 'CoreUserService', 'CoreCompanyService', 'CoreCommon', 'DashboardStateService', '$location', '$timeout', '$routeParams', 'HOST', 'UriService', 'SavedSearchService', 'PageStateService', 'InformationTypeService', 'TagSearchService', 'ContentStreamTypeFactory','INTERNAL_URL', 'InsWidgetConfigService', 'AnalyticsService', 'ANALYTICS_CONSTANTS', function searchListWidget(DashboardWidgetService, CoreSearchService, ContentBehaviorService, DashboardChartConfigService, CoreUserService, CoreCompanyService, CoreCommon, DashboardStateService, $location, $timeout, $routeParams, HOST, UriService, SavedSearchService, PageStateService, InformationTypeService, TagSearchService, ContentStreamTypeFactory, INTERNAL_URL, InsWidgetConfigService, AnalyticsService, ANALYTICS_CONSTANTS) {
    'use strict';

    var searchListWidgetObj,
        getResultsMax,
        searchListController,
        displayMode,
        queryObject,
        getDocumentAction,
        recentHitsConfig,
        applyRestrictions,
        searchListLink;

    searchListWidgetObj = DashboardWidgetService.getWidget('search-list-widget');

    getResultsMax = function getResultsMax(isReport, widgetSettings) {
        var max;

        if (isReport) {
            max = parseInt(UriService.load($location.url()).search(true).documentListMax);

            if (!max) {
                max = widgetSettings.articlesPerSearch;

                if(!max) {
                    max = 100;
                }
            }
        }

        if (!max) {
            max = 25;
        }

        return max;
    };

    searchListLink = function searchListLink($scope) {
        if($scope.widgetView === 'email') {
            displayMode = 'email';
        }
        else if($scope.isMaximized && !$scope.isReport){
            displayMode = 'full';
        }
        else {
            displayMode = 'skinny';
        }

        $scope.searchUrl = function searchUrl() {
            return $scope.searchIsReady() ? '/inbox/list/'+$scope.widget.settings.searchIds[0].searchId + '?locker=' + PageStateService.getLockerId('inboxListPage') +'&type=search&name=' + ($scope.widget.title ? encodeURIComponent($scope.widget.title) : '') : undefined;
        };



        var tagNames = false,
            searchIds = false,
            inputs = false;
        // Determine what this widget is using for an input style
        if($scope.widget && $scope.widget.settings){
            if ($scope.widget.settings.inputs && $scope.widget.settings.inputs.length > 0 ) {
                inputs = $scope.widget.settings.inputs;
            } else {
                if ($scope.widget.settings.searchIds !== undefined && $scope.widget.settings.searchIds.length > 0){
                    searchIds = $scope.widget.settings.searchIds;
                } else if ($scope.widget.settings.tagNames && $scope.widget.settings.tagNames.length > 0) {
                    tagNames = $scope.widget.settings.tagNames;
                }
            }
        }

        /**
         * Responsible for returning a URL depending on if the content was from a search or a tag
         * @param source contains source information about the page.
         * @returns {string , undefined}
         */
        $scope.getViewMoreResultsURL = function getViewMoreResultsURL(source) {
            var url, type;
            if (inputs) {
                var input = inputs[0];
                type = 'input';
                switch (input.inputType){
                    case 'news':
                    case 'social':
                        url = INTERNAL_URL + '/inbox/searches/' + input.id;
                    break;
                    case 'tags':
                        url = INTERNAL_URL + '/inbox/tags/' + input.name;
                    break;
                    case 'rss':
                        url = url = INTERNAL_URL + '/inbox/rssSources/' + input.id;
                    break;
                }

            // widget_inputs account for old style ***********
            } else if (searchIds) {
                type = 'search';
                url = INTERNAL_URL + '/inbox/searches/' + searchIds[0].searchId;
            } else if (tagNames) {
                type = 'tag';
                url = INTERNAL_URL + '/inbox/tags/' + tagNames[0].name;
            }
            if (source && url && type) {
                url = url +'?source='+ source + '&type=' + type;
            }
            return url;

        };

        $scope.$on('widgetFiltersUpdated', function initMaximizedWidget() {
            if ($scope.isMaximized) {
                $scope.initWidget();
            }
        });

        $scope.$on('contentStream_documentsUpdated', function contentStream_documentsUpdatedEvent() {
            $scope.searchIsLoading = false;
            $scope.widgetIsLoading = false;
            // Have to wait 100ms for angular to populate the ng-repeat, or clipRelativeTo will just clip relative to having 0 results.
            $timeout(function() {
                $scope.$broadcast('gyda.triggerClipRelativeTo');
            }, 100);
        });

        $scope.$on('widgetResized', function widgetResizedEvent() {
            $scope.$broadcast('gyda.triggerClipRelativeTo');
        });

        // We have different kinds of searches (social | news | rss | tags )
        if (inputs) {
            getDocumentAction = InsWidgetConfigService.getDocumentAction;
            recentHitsConfig = null;
        }

        // widget_inputs account for old style
        // Settings for tag names
        else if (tagNames) {
            getDocumentAction = TagSearchService.getContentStreamByTagName;
            recentHitsConfig = {
                endPoint: TagSearchService.getRecentHitsByTagName,
                enabled: $scope.isMaximized ? true : false
            };
        }
        // Settings for search ids
        else if (searchIds) {
            getDocumentAction = CoreSearchService.getContentStreamBySavedSearchId;
            recentHitsConfig = {
                endPoint: CoreSearchService.getRecentHitsBySavedSearchId,
                enabled: $scope.isMaximized ? true : false
            };

            // Lets use the getDocumentAction that bypasses the timezone interceptor so we use the custom dates we are requesting as is on the request for documents
            // FYI, currently used by news digest reports. Should be used with caution.
            if(typeof $scope.widget.settings.useFixedDates !== 'undefined' && $scope.widget.settings.useFixedDates === true) {
                //so override the action with a report specific one that basically adds a switch on the request header to tell the interceptor to not touch this.
                getDocumentAction = CoreSearchService.getContentStreamBySavedSearchIdFixedDateRange;
            }
        }


        applyRestrictions = {
            endPoint: ContentBehaviorService.applyRegionalRestriction,
            enabled: true
        };

        var buildDocumentUrl = function buildDocumentUrl(document) {
            var url = new UriService('/')
                .protocol($location.protocol())
                .hostname(HOST)
                .segment('dashboard').segment('viewer')
                // If these are somehow empty, we'll spit out a lot of interpolation errors and bring the app to a
                // crawl. Let's just generate a working (but invalid and clear) id instead.
                .segment(DashboardStateService.currentDashboard._id || 'MISSING_DASHBOARD_ID')
                .segment($scope.widget.id || 'MISSING_WIDGET_ID')
                .search({documentId: document.documentId});

            return url.toString();
        };

        var getParamsHelper = function getParamsHelper(elements, elementKey, paramKey) {
            var params = {};
            angular.forEach(elements, function (element) {
                if (element) {
                    params[paramKey] = params[paramKey] || [];
                    params[paramKey].push(element[elementKey]);
                }
            });
            return params;
        };

        var getInputsParams = function getInputsParams(inputs) {
            var params = {};
            angular.forEach(inputs, function (singleInput) {
                if (!singleInput) {
                    return;
                }
                switch (singleInput.inputType) {
                    case 'tags':
                        params.tags = params.tags || [];
                        params.tags.push(singleInput.name);
                        break;
                    case 'rss':
                        params.rssFeeds = params.rssFeeds || [];
                        params.rssFeeds.push(singleInput.id);
                        break;
                    default:
                        params.agents = params.agents || [];
                        params.agents.push(singleInput.id);
                        break;
                }
            });
            return params;
        };

        var getBaseContentStreamTypeConfig = function getBaseContentStreamTypeConfig(queryObject) {
            var contentStreamTypeConfig = {};

            if (queryObject.agents && queryObject.agents.length > 0) {
                contentStreamTypeConfig.searchIds = queryObject.agents;
            } else if(queryObject.tags && queryObject.tags.length > 0) {
                contentStreamTypeConfig.tags = queryObject.tags;
            } else if(queryObject.rssFeeds && queryObject.rssFeeds.length > 0) {
                contentStreamTypeConfig.rssFeeds = queryObject.rssFeeds;
            } else if(inputs && inputs.length === 1) { // For handle the search report.
                switch (inputs[0].inputType) {
                    case 'news':
                    case 'social':
                        contentStreamTypeConfig = {informationTypes: [inputs[0].inputType]};
                        break;
                }
            }

            return contentStreamTypeConfig;
        };

        var getData = function getData(inputs, tagNames, searchIds) {
            var name = '',
                params;
            if(inputs) {
                name = inputs[0].name;
                params = getInputsParams(inputs);
            } else if(tagNames) {
                name = tagNames[0].name;
                params = getParamsHelper(tagNames, 'name', 'tags');
            } else if(searchIds) {
                name = searchIds[0].name;
                params = getParamsHelper(searchIds, 'searchId', 'agents');
            }
            return {
                params: params,
                name: name  //We return the name for the search reports.
            };
        };

        $scope.initWidget = function () {
            var filters,
                dateRange = {},
                data,
                params,
                name,
                contentStreamConfig = null,
                contentStreamTypeConfig = null;

            if ($scope.searchIsReady()) {
                $scope.widgetIsLoading = true;
                $scope.searchIsLoading = true;

                data = getData(inputs, tagNames, searchIds);
                params = data.params;
                name = data.name;
                contentStreamTypeConfig = getBaseContentStreamTypeConfig(params);

                filters = DashboardChartConfigService.setFilters($scope.widget);

                //if there is a custom date range set on the widget use that
                if ($scope.widget.settings && $scope.widget.settings.customDateRange && $scope.widget.settings.dateRange && $scope.widget.settings.dateRange.absoluteStartDate && $scope.widget.settings.dateRange.absoluteEndDate) {
                    dateRange.dateStart = CoreUserService.adjustDate($scope.widget.settings.dateRange.absoluteStartDate);
                    dateRange.dateEnd   = CoreUserService.adjustDate($scope.widget.settings.dateRange.absoluteEndDate);
                } else {
                    //Set the date by default for the dashboard view/max widget date range view
                    //This is on max view or dashboard view (dashboard range whether its custom search dashboard or gyda)
                    dateRange.dateStart = CoreUserService.adjustDate(DashboardStateService.currentDashboard.currentDateRange.absoluteStartDate);
                    dateRange.dateEnd   = CoreUserService.adjustDate(DashboardStateService.currentDashboard.currentDateRange.absoluteEndDate);
                }
                queryObject = {
                    pageSize: getResultsMax($scope.isReport, $scope.widget.settings),
                    page: 0,
                    name: name,
                    filters: filters,
                    dateStart: dateRange.dateStart,
                    dateEnd: dateRange.dateEnd,
                    sortField: 'date',
                    sortOrder: 'DESC',
                    productType: $scope.isReport ? 'dashboard_report' : 'dashboard_content_stream_min_view'
                };
                angular.extend(queryObject, params);

                var userSettings = CoreUserService.getAppSettings('search');

                if (userSettings && userSettings.groupOption) {
                    queryObject.groupOption = userSettings.groupOption;
                } else if ($scope.widget.settings.groupOption) {
                    queryObject.groupOption = $scope.widget.settings.groupOption;
                }

                if(typeof $scope.widget.settings.useReportApi !== 'undefined' && $scope.widget.settings.useReportApi === true) {
                    queryObject.useReportApi = true;
                }

                contentStreamConfig = {
                    displayMode: displayMode,
                    isDashboardReport: ($scope.reportContentType && $scope.reportContentType === 'dashboard'),
                    getDocumentAction : getDocumentAction,
                    initialQueryObject: queryObject,
                    recentHits : recentHitsConfig,
                    applyRestrictions : applyRestrictions,
                    fullContentDialog: ContentBehaviorService.openFullContent,
                    buildDocumentUrl: buildDocumentUrl,
                    displayAvatarImage: ($scope.widget.settings.displayAvatarImage !== undefined) ? $scope.widget.settings.displayAvatarImage : true,
                    displayOpeningText: ($scope.widget.settings.displayOpeningText !== undefined) ? $scope.widget.settings.displayOpeningText : userSettings.openingText !== undefined ? userSettings.openingText : true,
                    displayHitSentence: ($scope.widget.settings.displayHitSentence !== undefined) ? $scope.widget.settings.displayHitSentence : userSettings.hitSentence !== undefined ? userSettings.hitSentence : true,
                    displayInlineImage: false,
                    savedSearchData: {
                        widget: $scope.widget,
                        dashboard: $scope.dashboard
                    }
                };

                if(displayMode === 'skinny') {
                    contentStreamConfig.documentClick = function documentClick (event, document, fullContentDialog, url, analytics) {
                        var documentDetail = {
                            document: document,
                            parentType: ANALYTICS_CONSTANTS.DASHBOARD,
                            label : ANALYTICS_CONSTANTS.OPEN,
                            sourceDetail: document.source,
                            uId: CoreUserService.getId(),
                            cId: CoreCompanyService.getId()
                        };
                        event.preventDefault();

                        AnalyticsService.documentOperation(documentDetail);
                        ContentBehaviorService.documentClick(document, url)
                    }
                }
                $scope.contentStreamType = ContentStreamTypeFactory.buildTypeForQuery(contentStreamTypeConfig, contentStreamConfig);
                // We need to pass this value for excel exports.
                $scope.contentStreamType.savedSearchData = $scope.contentStreamType.savedSearchData || {
                    widget: $scope.widget,
                    dashboard: $scope.dashboard
                };
                if($scope.dashboard && $scope.dashboard.id && $scope.dashboard.id === 'searchListDb') {
                    $scope.maximize = function() {
                        $location.path('/search/edit/keywordSearch/' + $scope.widget.settings.searchIds[0].searchId + '?editMode=false');
                    };
                }
            }

            if($routeParams.documentId){
                ContentBehaviorService.openFullContent($routeParams.documentId);
            }
        };

        $scope.searchIsReady = function searchIsReady() {
            return (inputs || tagNames || searchIds);
        };

        $scope.initialize = function initialize() {
            // We use the same content stream as the one on the inbox when the widget is maximized.
            // So don't need to use the old content stream implementation.
            if(!$scope.isMaximized) {
                $scope.initWidget();
            } else {
                $scope.searchIsLoading = false;
                $scope.widgetIsLoading = false;
            }
        };

        $scope.initialize();
    };

    searchListController = function searchListController($scope) {
        // TODO: remove this when we want the Dashboard & Search reports to match, until then we need to differentiate - GYDA-5355
        if($scope.reportContentType && $scope.reportContentType === 'dashboard') {
            searchListWidgetObj.emailViewFile = 'search_list_widget_dashboard_email';
        }

        $scope.$on('widgetFiltersUpdated', function () {
            $scope.initWidget();
        });
    };

    return new WidgetDirective(searchListWidgetObj, searchListLink, searchListController);
}]);
